// extracted by css-extract-rspack-plugin
export default {"DateRangeStringsEditor":"DateRangeStringsEditor-dclDG1","dateRangeStringsEditor":"DateRangeStringsEditor-dclDG1"};